/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { apiAgencybarcodeDelete } from '../fn/agency-barcode/api-agencybarcode-delete';
import { ApiAgencybarcodeDelete$Params } from '../fn/agency-barcode/api-agencybarcode-delete';
import { apiAgencybarcodePost } from '../fn/agency-barcode/api-agencybarcode-post';
import { ApiAgencybarcodePost$Params } from '../fn/agency-barcode/api-agencybarcode-post';
import { apiAgencybarcodePut } from '../fn/agency-barcode/api-agencybarcode-put';
import { ApiAgencybarcodePut$Params } from '../fn/agency-barcode/api-agencybarcode-put';
import { NotificationMessage } from '../models/notification-message';

@Injectable({ providedIn: 'root' })
export class AgencyBarcodeService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `apiAgencybarcodePut()` */
  static readonly ApiAgencybarcodePutPath = '/api/agencybarcode';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiAgencybarcodePut()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiAgencybarcodePut$Response(params?: ApiAgencybarcodePut$Params, context?: HttpContext): Observable<StrictHttpResponse<NotificationMessage>> {
    return apiAgencybarcodePut(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiAgencybarcodePut$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiAgencybarcodePut(params?: ApiAgencybarcodePut$Params, context?: HttpContext): Observable<NotificationMessage> {
    return this.apiAgencybarcodePut$Response(params, context).pipe(
      map((r: StrictHttpResponse<NotificationMessage>): NotificationMessage => r.body)
    );
  }

  /** Path part for operation `apiAgencybarcodePost()` */
  static readonly ApiAgencybarcodePostPath = '/api/agencybarcode';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiAgencybarcodePost()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiAgencybarcodePost$Response(params?: ApiAgencybarcodePost$Params, context?: HttpContext): Observable<StrictHttpResponse<NotificationMessage>> {
    return apiAgencybarcodePost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiAgencybarcodePost$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiAgencybarcodePost(params?: ApiAgencybarcodePost$Params, context?: HttpContext): Observable<NotificationMessage> {
    return this.apiAgencybarcodePost$Response(params, context).pipe(
      map((r: StrictHttpResponse<NotificationMessage>): NotificationMessage => r.body)
    );
  }

  /** Path part for operation `apiAgencybarcodeDelete()` */
  static readonly ApiAgencybarcodeDeletePath = '/api/agencybarcode';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiAgencybarcodeDelete()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiAgencybarcodeDelete$Response(params?: ApiAgencybarcodeDelete$Params, context?: HttpContext): Observable<StrictHttpResponse<NotificationMessage>> {
    return apiAgencybarcodeDelete(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiAgencybarcodeDelete$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiAgencybarcodeDelete(params?: ApiAgencybarcodeDelete$Params, context?: HttpContext): Observable<NotificationMessage> {
    return this.apiAgencybarcodeDelete$Response(params, context).pipe(
      map((r: StrictHttpResponse<NotificationMessage>): NotificationMessage => r.body)
    );
  }

}
